export default __webpack_public_path__ + "static/media/img-0450-luxembourg-half-face.741f3dc6.png";